import React from "react";
import { useTranslation } from "react-i18next";
import useAnalyticsContext from "../../hooks/useAnalyticsContext.js";
import { trackSectionViewed, useSectionOnceObserver } from "../../lib/analytics";
import { WPS_SECTION } from "./sections.js";

/**
 * "One scan. Every memory." — the four-step guest flow.
 *
 * Uses the same markup and classes as the home `Journey` section (`list-wrap` /
 * `list-row` / `no-div` / `row-heading-div` / `row-body-div serv`) so the
 * numbered-step language is identical across the site.
 *
 * The step copy describes the REAL flow: the QR opens the join page, the guest
 * enters a name, and uploading happens once they are inside their wedding
 * experience. It must never say the QR opens the uploader directly.
 */
const STEP_KEYS = ["scan", "join", "share", "remember"];

const PhotoSharingSteps = ({ id }) => {
  const { t } = useTranslation();

  const analyticsContext = useAnalyticsContext();

  // One impression the first time the section scrolls into view; the observer
  // disconnects itself afterwards.
  const sectionRef = useSectionOnceObserver(() =>
    trackSectionViewed(WPS_SECTION.STEPS, analyticsContext),
  );

  return (
    <section ref={sectionRef} id={id} className="section wps-section">
      <div className="container home-serv">
        <div className="full-header-div">
          <div className="pad-20">
            <h2 className="heading-136">
              {t("weddingPhotoSharing.steps.heading")}
            </h2>
          </div>
        </div>
        <ol className="list-wrap wps-steps">
          {STEP_KEYS.map((key, index) => (
            <li key={key} className="list-row">
              <div className="no-div">
                <div className="no">
                  {t("weddingPhotoSharing.steps.stepLabel", {
                    number: index + 1,
                  })}
                </div>
              </div>
              <div className="row-heading-div">
                <h3 className="heading-38">
                  {t(`weddingPhotoSharing.steps.items.${key}.title`)}
                </h3>
              </div>
              <div className="row-body-div serv">
                <p className="body-15">
                  {t(`weddingPhotoSharing.steps.items.${key}.body`)}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default PhotoSharingSteps;
